import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomUpdateAiMappingSegmentationMutation } from "generated/graphql";

export const useUpdateAiMappingSegmentation = () => {
  const [mutation, { data, loading, error }] = useCustomUpdateAiMappingSegmentationMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "updateAiMappingSegmentation" },
    { hideMessage: true }
  );
};
